import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Text } from "@mantine/core";
import Link from "next/link";
import { ReactNode, useMemo } from "react";

interface TableEmptyStateProps {
  buttonIcon?: IconDefinition;
  buttonText?: string;
  href?: string;
  message: ReactNode;
  onClick?: () => void;
}

export const tableEmptyStateClearFiltersProps = (
  modelName: string,
  hasClearableFilters: boolean,
  onClick: () => void,
) => ({
  buttonText: hasClearableFilters ? "Clear Filters" : undefined,
  message: `No ${modelName} found${hasClearableFilters ? " matching current filters." : ""}`,
  onClick,
});

export const TableEmptyState = ({
  buttonIcon,
  buttonText,
  href,
  message,
  onClick,
}: TableEmptyStateProps) => {
  const button = useMemo(() => {
    if (!buttonText) {
      return null;
    }

    const sharedProps = {
      children: buttonText,
      className: "uppercase",
      leftSection: buttonIcon ? <FontAwesomeIcon icon={buttonIcon} /> : null,
      onClick,
      variant: "transparent",
    };

    if (href) {
      return <Button {...sharedProps} component={Link} href={href} />;
    }

    return <Button {...sharedProps} />;
  }, [buttonIcon, buttonText, href, onClick]);

  return (
    <>
      <Text className="text-uw-gray-9" mb={8} size="sm">
        {message}
      </Text>
      {button}
    </>
  );
};
